import React from 'react';
import styles from '@dazn/lp-web/src/components/ContentTiers/ComparePlan/compare-plan.module.css';
import {TBillingPeriod} from '@dazn/lp-web/src/types';
import {triggerElementClick} from '@dazn/lp-web/src/analytics/fe-events';
import {elementClickEventTypes} from '@dazn/lp-web/src/analytics/fe-events/elementClick';

interface PlanButtonProps {
    label: string;
    badge: boolean;
    tag: string;
    value: any;
    onClick: (value: TBillingPeriod) => void;
    className: string;
}

const PlanButton: React.FC<PlanButtonProps> = ({
    label,
    value,
    badge,
    tag,
    onClick,
    className
}) => {
    return (
        <div>
            <button
                className={className}
                onClick={() => {
                    triggerElementClick({
                        section: elementClickEventTypes.BODY,
                        itemId:
                            value === 'Month'
                                ? 'lp_monthly_subscription_cta'
                                : value === 'Instalments'
                                ? 'lp_annual_subscription_cta'
                                : 'lp_plan_selector_cta',
                        resourceString: label || ''
                    });
                    onClick(value);
                }}
            >
                {label}
                {badge && <span className={styles.saveButton}>{tag}</span>}
            </button>
        </div>
    );
};

export default PlanButton;
